export enum ISentimentReportEnum {
  Id = 'SentimentReport.id',
  AccountId = 'SentimentReport.accountid',
  UserId = 'SentimentReport.userid',
  Date = 'SentimentReport.date',
  LocalDate = 'SentimentReport.localdate',
  ReportType = 'SentimentReport.reporttype',
  Score = 'SentimentReport.score',
  Notes = 'SentimentReport.notes',
  CreatedAt = 'SentimentReport.createdat',
  UpdatedAt = 'SentimentReport.updatedat',
  CreatedBy = 'SentimentReport.createdby',
  UpdatedBy = 'SentimentReport.updatedby',
  DeletedAt = 'SentimentReport.deletedat',
  DeletedBy = 'SentimentReport.deletedby',
  Count = 'SentimentReport.count',
  NegativeCount = 'SentimentReport.negativecount',
  NeutralCount = 'SentimentReport.neutralcount',
  PositiveCount = 'SentimentReport.positivecount',
  TotalScore = 'SentimentReport.totalscore',
  DayCount = 'SentimentReport.daycount',
}
